@if (!carregando) {
  <div class="dashboard-promocoes-page" [@esvanecerDesvanecer]="'in'">
    <div class="dashboard-promocoes-topbar">
      <div>
        <h1>Dashboard &gt; Uso Promocoes</h1>
        <p>Acompanhamento das campanhas promocionais, produtos e uso por vendedor.</p>
      </div>

      <div class="dashboard-promocoes-filtros">
        <label class="dashboard-promocoes-filtro-promocao">
          <span>Promocao</span>
          <input type="text" [(ngModel)]="promocaoFiltro" [ngModelOptions]="{standalone: true}" placeholder="Buscar promocao" autocomplete="off">
        </label>
        <label>
          <span>Inicio</span>
          <input type="date" [(ngModel)]="dataInicio" [ngModelOptions]="{standalone: true}" >
        </label>
        <label>
          <span>Fim</span>
          <input [appPeriodoFinal]="dataInicio" type="date" [(ngModel)]="dataFim" [ngModelOptions]="{standalone: true}">
          @if (erroPeriodo) { <small class="text-danger" role="alert">{{ erroPeriodo }}</small> }
        </label>
        <label>
          <span>Tipo</span>
          <select [(ngModel)]="tipoDados" [ngModelOptions]="{standalone: true}">
            <option value="FATURADO">Faturado</option>
            <option value="GERAL">Geral</option>
          </select>
        </label>
        <button type="button" (click)="atualizar()">Atualizar</button>
      </div>
    </div>

    <div class="dashboard-promocoes-kpis">
      <div class="dashboard-promocoes-kpi">
        <span>{{ abaAtiva == 'tabela' ? 'Tabelas usadas' : 'Promocoes usadas' }}</span>
        <strong>{{ totalPromocoesUsadasAba() | number: '1.0-0' }}</strong>
      </div>

      <div class="dashboard-promocoes-kpi">
        <span>Vendas em reais</span>
        <strong>{{ totalVendasReaisAba() | currency: 'BRL' }}</strong>
      </div>

      <div class="dashboard-promocoes-kpi">
        <span>Quantidade vendida</span>
        <strong>{{ totalQuantidadeAba() | number: '1.0-0' }}</strong>
      </div>

      <div class="dashboard-promocoes-kpi">
        <span>Litros vendidos</span>
        <strong>{{ totalLitrosAba() | number: '1.0-0' }} L</strong>
      </div>

      <div class="dashboard-promocoes-kpi">
        <span>Pedidos</span>
        <strong>{{ totalPedidosAba() | number: '1.0-0' }}</strong>
      </div>
    </div>

    <section class="dashboard-promocoes-panel">
      <div class="dashboard-promocoes-tabs">
        <button type="button" [class.active]="abaAtiva == 'promocao'" (click)="alterarAba('promocao')">
          Promocao
          <span>{{ totalPromocoesAba() | number: '1.0-0' }}</span>
        </button>
        <button type="button" [class.active]="abaAtiva == 'tabela'" (click)="alterarAba('tabela')">
          Tabela Especial
          <span>{{ totalTabelasAba() | number: '1.0-0' }}</span>
        </button>
      </div>

      <div class="dashboard-promocoes-panel-header">
        <h2>{{ abaAtiva == 'tabela' ? 'Uso por tabela especial' : 'Uso por promocao' }}</h2>
        <div class="dashboard-promocoes-panel-actions">
          <label class="dashboard-promocoes-select">
            <span>Ordenar por</span>
            <select [(ngModel)]="ordenacao" [ngModelOptions]="{standalone: true}">
              <option value="valor">R$</option>
              <option value="quantidade">Qtd</option>
              <option value="litros">Litros</option>
              <option value="pedidos">Pedidos</option>
            </select>
          </label>
          <span>{{ promocoesFiltradas().length | number: '1.0-0' }} {{ abaAtiva == 'tabela' ? 'tabelas' : 'promocoes' }}</span>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm dashboard-promocoes-table mb-0">
          <thead>
            <tr>
              <th>{{ abaAtiva == 'tabela' ? 'Tabela especial' : 'Promocao' }}</th>
              <th class="text-right">Vendas R$</th>
              <th class="text-right">Qtde</th>
              <th class="text-right">Litros</th>
              <th class="text-right">Pedidos</th>
              <th class="text-right">Produtos</th>
              <th class="text-right">Vendedores</th>
            </tr>
          </thead>
          <tbody>
            @for (promocao of promocoesFiltradas(); track promocao.promocaoId) {
              <tr>
                <td>
                  <b>{{ promocao.promocao }}</b>
                  @if (promocao.flagNaoAplicaFatorPontuacaoFin) {
                    <small>Sem fator financeiro</small>
                  }
                </td>
                <td class="text-right">{{ promocao.vendasReais | currency: 'BRL' }}</td>
                <td class="text-right">{{ promocao.quantidade | number: '1.0-0' }}</td>
                <td class="text-right">{{ promocao.litros | number: '1.0-0' }} L</td>
                <td class="text-right">{{ promocao.pedidos | number: '1.0-0' }}</td>
                <td class="text-right">
                  <button type="button" (click)="alternarProdutosPromocao(promocao)">
                    {{ promocaoProdutosAberta == promocao.promocaoId ? 'Ocultar' : 'Produtos' }}
                  </button>
                </td>
                <td class="text-right">
                  <button type="button" (click)="alternarVendedoresPromocao(promocao)">
                    {{ promocaoVendedoresAberta == promocao.promocaoId ? 'Ocultar' : 'Vendedores' }}
                  </button>
                </td>
              </tr>

              @if (promocaoVendedoresAberta == promocao.promocaoId) {
                <tr>
                  <td colspan="7" class="dashboard-promocoes-details">
                    <h3>Vendedores que utilizaram a promocao</h3>
                    @if (promocao.sellers.length > 0) {
                      <table class="table table-sm dashboard-promocoes-inner-table mb-0">
                        <thead>
                          <tr>
                            <th>Vendedor</th>
                            <th class="text-right">Vendas R$</th>
                            <th class="text-right">Qtde</th>
                            <th class="text-right">Litros</th>
                            <th class="text-right">Pedidos</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (seller of promocao.sellers; track seller.sellerId) {
                            <tr>
                              <td>{{ seller.vendedor }}</td>
                              <td class="text-right">{{ seller.vendasReais | currency: 'BRL' }}</td>
                              <td class="text-right">{{ seller.quantidade | number: '1.0-0' }}</td>
                              <td class="text-right">{{ seller.litros | number: '1.0-0' }} L</td>
                              <td class="text-right">{{ seller.pedidos | number: '1.0-0' }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    } @else {
                      <div class="dashboard-promocoes-empty">Sem uso por vendedor no periodo selecionado.</div>
                    }
                  </td>
                </tr>
              }

              @if (promocaoProdutosAberta == promocao.promocaoId) {
                <tr>
                  <td colspan="7" class="dashboard-promocoes-details">
                    <h3>Produtos da promocao</h3>
                    @if (produtosDaPromocao(promocao.promocaoId).length > 0) {
                      <table class="table table-sm dashboard-promocoes-inner-table dashboard-promocoes-produtos-table mb-0">
                        <thead>
                          <tr>
                            <th>Produto</th>
                            <th class="text-right">Preco promocao</th>
                            <th class="text-right">Vendas R$</th>
                            <th class="text-right">Qtde</th>
                            <th class="text-right">Litros</th>
                            <th class="text-right">Pedidos</th>
                            <th class="text-right">Vendedores</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (produto of produtosDaPromocao(promocao.promocaoId); track produto.produtoEspecialId) {
                            <tr>
                              <td>
                                <b>{{ produto.produto }}</b>
                                <small>{{ produto.codigo }}</small>
                              </td>
                              <td class="text-right">{{ produto.precoPromocao | currency: 'BRL' }}</td>
                              <td class="text-right">{{ produto.vendasReais | currency: 'BRL' }}</td>
                              <td class="text-right">{{ produto.quantidade | number: '1.0-0' }}</td>
                              <td class="text-right">{{ produto.litros | number: '1.0-0' }} L</td>
                              <td class="text-right">{{ produto.pedidos | number: '1.0-0' }}</td>
                              <td class="text-right">
                                <button type="button" (click)="alternarProduto(produto)">
                                  {{ produtoAberto == produto.produtoEspecialId ? 'Ocultar' : 'Vendedores' }}
                                </button>
                              </td>
                            </tr>
                            @if (produtoAberto == produto.produtoEspecialId) {
                              <tr>
                                <td colspan="7" class="dashboard-promocoes-product-details">
                                  @if (produto.sellers.length > 0) {
                                    <table class="table table-sm dashboard-promocoes-inner-table mb-0">
                                      <thead>
                                        <tr>
                                          <th>Vendedor</th>
                                          <th class="text-right">Vendas R$</th>
                                          <th class="text-right">Qtde</th>
                                          <th class="text-right">Litros</th>
                                          <th class="text-right">Pedidos</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (seller of produto.sellers; track seller.sellerId) {
                                          <tr>
                                            <td>{{ seller.vendedor }}</td>
                                            <td class="text-right">{{ seller.vendasReais | currency: 'BRL' }}</td>
                                            <td class="text-right">{{ seller.quantidade | number: '1.0-0' }}</td>
                                            <td class="text-right">{{ seller.litros | number: '1.0-0' }} L</td>
                                            <td class="text-right">{{ seller.pedidos | number: '1.0-0' }}</td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  } @else {
                                    <div class="dashboard-promocoes-empty">Sem uso por vendedor no periodo selecionado.</div>
                                  }
                                </td>
                              </tr>
                            }
                          }
                        </tbody>
                      </table>
                    } @else {
                      <div class="dashboard-promocoes-empty">Nenhum produto encontrado para esta promocao.</div>
                    }
                  </td>
                </tr>
              }
            }
            @if (promocoesFiltradas().length == 0) {
              <tr>
                <td colspan="7" class="text-center dashboard-promocoes-empty">Nenhuma promocao encontrada.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  </div>
}
